import _ from "lodash";

export interface IErrorText {
    text: string;
    highlight?: boolean;
}

export type ErrorMessage = string | IErrorText;

function getErrorText(message: any) : IErrorText {
    if (typeof message === 'string') {
        return { text: message };
    } else if (typeof message?.text === 'string') {
        return message;
    } else {
        return { text: '' };
    }
}

export class ErrorInfo {
    code: string;
    messages: IErrorText[];
    source: any;
    action: any;
    actiontext: any;

    constructor(code: string, messages?: ErrorMessage[]) {
        this.code = code;
        this.messages = _.map(messages, getErrorText);
        this.source = null;
        this.action = null;
        this.actiontext = null;
    }
}
